'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkWrapper = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _DefaultLinkComponent = require('./DefaultLinkComponent');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  href: _propTypes2.default.string,
  boxed: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  icon: _propTypes2.default.shape({
    /** Set icon's name (required for font-awesome icons */
    name: _propTypes2.default.string,

    /** Set icon's source (required for library icons */
    src: _propTypes2.default.string,

    /** Set icon type */
    type: _propTypes2.default.oneOf(['font-awesome', 'library'])
  }),
  onClick: _propTypes2.default.func,
  linkComponent: _propTypes2.default.func
};
var defaultProps = {
  href: '#',
  boxed: false,
  title: '',
  icon: {
    name: '',
    src: '',
    type: 'font-awesome'
  },
  onClick: _reactackleCore.noop,
  linkComponent: _DefaultLinkComponent.DefaultLinkComponent
};

var LinkWrapper = function LinkWrapper(props) {
  var Link = props.linkComponent,
      linkProps = _objectWithoutProperties(props, ['linkComponent']);

  if (Link !== _DefaultLinkComponent.DefaultLinkComponent) delete linkProps.boxed;
  return _react2.default.createElement(Link, linkProps, props.children);
};

exports.LinkWrapper = LinkWrapper;
LinkWrapper.propTypes = propTypes;
LinkWrapper.defaultProps = defaultProps;
LinkWrapper.displayName = 'LinkWrapper';